import { inject } from "@angular/core";
import { Routes } from "@angular/router";

import { Permissions } from "src/assets/config/config";
import { errorRoutes } from "./features/error";
import { profileRoutes } from "./features/profile";
import { overviewRoutes } from "./features/overview";
import { myTicketsRoutes } from "./features/my-tickets";
import { myRequestsRoutes } from "./features/my-requests";
import { evaluationInterestsRoutes } from "./features/evaluations-interests";
import { adminRoutes, authRoutes, servicesRoutes } from "./features";
import { ApplicationUserTypeName, authGuard, AuthService, landingGuard, roleGuard } from "./core";

export const routes: Routes = [
  { path: "", redirectTo: "overview", pathMatch: "full" },
  {
    path: "auth",
    canActivate: [authGuard],
    children: authRoutes,
  },
  {
    path: "overview",
    canActivate: [landingGuard],
    children: overviewRoutes,
  },
  {
    path: "transaction/:transactionType",
    loadComponent: () => import("src/app/shared/components/ticket/ticket.component").then((c) => c.TicketComponent),
  },
  {
    path: "ticket/:reservationNumber",
    loadComponent: () => import("src/app/shared/components/ticket/ticket.component").then((c) => c.TicketComponent),
  },
  {
    path: "invoice/:id",
    loadComponent: () => import("src/app/shared/components/invoice/invoice.component").then((c) => c.InvoiceComponent),
  },
  {
    path: "failed-invoice/:id",
    loadComponent: () => import("src/app/shared/components/invoice/invoice.component").then((c) => c.InvoiceComponent),
  },
  {
    path: "",
    canActivate: [authGuard],
    loadComponent: () => import("./core/components/layout/layout.component").then((c) => c.LayoutComponent),
    children: [
      { path: "", redirectTo: "services", pathMatch: "full" },
      {
        path: "",
        children: [
          {
            path: "profile",
            canActivate: [roleGuard],
            data: { permissions: Permissions.Profile },
            children: profileRoutes,
          },
          {
            path: "services",
            canActivate: [roleGuard],
            data: { permissions: Permissions.Services },
            children: servicesRoutes,
          },
          {
            path: "my-tickets",
            canActivate: [roleGuard],
            data: { permissions: Permissions.MyTickets },
            children: myTicketsRoutes,
          },
          {
            path: "my-requests",
            canActivate: [roleGuard],
            canMatch: [
              () =>
                [ApplicationUserTypeName.Client, ApplicationUserTypeName.Membership, ApplicationUserTypeName.CompanyMembership].includes(
                  inject(AuthService).userType()!,
                ),
            ],
            data: { permissions: Permissions.MyRequests },
            children: myRequestsRoutes,
          },
          {
            path: "admin",
            canActivateChild: [roleGuard],
            data: { permissions: Permissions.Admin },
            children: adminRoutes,
          },
          {
            path: "evaluations-interests",
            canActivate: [roleGuard],
            canMatch: [() => inject(AuthService).isMembershipUser()],
            data: { permissions: Permissions.EvaluationsInterests },
            children: evaluationInterestsRoutes,
          },
        ],
      },
    ],
  },
  {
    path: "error",
    canActivate: [authGuard],
    children: errorRoutes,
  },
  { path: "**", redirectTo: "error/404" },
];
